// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-up-down';

export const Component = () => (
  <path d='M15.306 10.679a.873.873 0 0 1 .725.233c.19.184.28.443.241.7v7.784l3.129-2.987a.74.74 0 0 1 .644-.367.74.74 0 0 1 .644.367.83.83 0 0 1 .311.644.83.83 0 0 1-.311.644l-4.531 4.375a.871.871 0 0 1-.852.423.829.829 0 0 1-.81-.427L9.97 17.697a.745.745 0 0 1-.38-.644c0-.265.145-.51.38-.644a.74.74 0 0 1 .644-.367.74.74 0 0 1 .644.367l3.13 3.021v-7.818a.793.793 0 0 1 .22-.686.857.857 0 0 1 .7-.247ZM9.58 2.5l.115.005h.46v.096a.69.69 0 0 1 .35.333l4.526 4.37c.235.134.38.379.38.643 0 .265-.145.51-.38.644a.74.74 0 0 1-.644.367.74.74 0 0 1-.644-.367l-3.128-3.02v7.817a.793.793 0 0 1-.222.686.857.857 0 0 1-.698.247.873.873 0 0 1-.725-.233.807.807 0 0 1-.241-.7V5.604l-3.13 2.987a.74.74 0 0 1-.644.367.74.74 0 0 1-.644-.367A.83.83 0 0 1 4 7.947a.83.83 0 0 1 .311-.644l4.531-4.375a.871.871 0 0 1 .852-.423Z' />
);

export const viewBox = '0 0 25 25';
